import { Box, Typography } from "@mui/material";
import { Button } from "@src/components";
import React from "react";
import { SelectPeriodButton } from "../Sections/TopPositions/components/SelectPeriodButton";

interface AggregatorSelectProps {
  availableAggregators: string[];
  selectedAggregators: string[];
  onAggregatorSelected: (aggregator: string[]) => void;
  onPeriodSelected: (start: Date, end: Date) => void;
  isMultiSelect: boolean;
  title: string;
  disabled?: boolean;
}

export const AggregatorSelect: React.FC<AggregatorSelectProps> = (props) => {
  const getSelectedAggregatorArray = (val: string) => {
    if (!props.isMultiSelect) {
      return [val];
    }

    if (val === "all") {
      return ["all"];
    }

    if (props.selectedAggregators.includes("all")) {
      const arr = props.selectedAggregators.filter((e) => e !== "all");

      return [...arr, val];
    }

    if (props.selectedAggregators.includes(val)) {
      if (props.selectedAggregators.length === 1) {
        return props.selectedAggregators;
      }
      const arr = props.selectedAggregators.filter((e) => e !== val);

      return arr;
    }

    return [...props.selectedAggregators, val];
  };

  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"space-between"}
      width={"100%"}
    >
      <Box display={"flex"} flexDirection={"row"}>
        <Typography fontSize={"32px"} fontWeight={"700"} marginRight={"10px"}>
          {props.title}
        </Typography>
        {props.availableAggregators.map((aggregator) => {
          return (
            <AggregatorButton
              key={aggregator}
              aggregator={aggregator}
              isSelected={props.selectedAggregators.includes(aggregator)}
              disabled={props.disabled}
              onSelected={(val) => {
                const aggregators = getSelectedAggregatorArray(val);
                props.onAggregatorSelected(aggregators);
              }}
            />
          );
        })}
      </Box>

      <SelectPeriodButton onPeriodSelected={props.onPeriodSelected} />
    </Box>
  );
};

interface AggregatorButtonProps {
  aggregator: string;
  isSelected: boolean;
  onSelected: (val: string) => void;
  disabled?: boolean;
}

const aggregatorConfig = new Map([
  ["glovo", "#FFAE3B"],
  ["wolt", "#4BB1DF"],
  ["yandex", "#FFE033"],
  ["all", "#39d29f"],
]);

const aggregatorTextColorConfig = new Map([
  ["glovo", "white"],
  ["wolt", "white"],
  ["yandex", "black"],
  ["all", "white"],
]);

const aggregatorNameConfig = new Map([
  ["glovo", "Glovo"],
  ["wolt", "Wolt"],
  ["yandex", "Yandex"],
  ["all", "Все"],
]);

/// function to get fill color for aggregator
export function getAggregatorColor(aggregator: string): any {
  return aggregatorConfig.get(aggregator);
}

const AggregatorButton: React.FC<AggregatorButtonProps> = (props) => {
  return (
    <Button
      onClick={() => props.onSelected(props.aggregator)}
      disabled={props.disabled}
      sx={{
        marginRight: "15px",
        bgcolor: props.isSelected
          ? getAggregatorColor(props.aggregator)
          : "#E8E8E9",

        "&:hover": {
          opacity: 0.8,
          bgcolor: props.isSelected
            ? getAggregatorColor(props.aggregator)
            : "#E8E8E9",
        },
        "& .MuiTouchRipple-root span": {
          backgroundColor: getAggregatorColor(props.aggregator),
          opacity: 0.3,
        },
      }}
    >
      <Typography
        color={
          props.isSelected
            ? aggregatorTextColorConfig.get(props.aggregator) ?? "white"
            : "black"
        }
      >
        {aggregatorNameConfig.get(props.aggregator)}
      </Typography>
    </Button>
  );
};